var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.69 9.16003H22.36C20.1508 9.16003 18.36 10.9509 18.36 13.16V38.18C18.36 40.3892 20.1508 42.18 22.36 42.18H65.69C67.8991 42.18 69.69 40.3892 69.69 38.18V13.16C69.69 10.9509 67.8991 9.16003 65.69 9.16003Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.53 20.19C62.0543 20.19 63.29 18.9543 63.29 17.43C63.29 15.9057 62.0543 14.67 60.53 14.67C59.0057 14.67 57.77 15.9057 57.77 17.43C57.77 18.9543 59.0057 20.19 60.53 20.19Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.86 31.1701L31.19 18.3301L45.86 33.0001L51.36 25.6701L64.19 36.6701",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62.3301C47.0376 62.3301 49.5 59.8676 49.5 56.8301C49.5 53.7925 47.0376 51.3301 44 51.3301C40.9624 51.3301 38.5 53.7925 38.5 56.8301C38.5 59.8676 40.9624 62.3301 44 62.3301Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.89 66H47.17C50.48 66 53.17 68.69 53.17 72V78.83H34.89V72C34.89 68.69 37.58 66 40.89 66Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.97 62.3301C69.0075 62.3301 71.47 59.8676 71.47 56.8301C71.47 53.7925 69.0075 51.3301 65.97 51.3301C62.9324 51.3301 60.47 53.7925 60.47 56.8301C60.47 59.8676 62.9324 62.3301 65.97 62.3301Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.86 66H69.14C72.45 66 75.14 68.69 75.14 72V78.83H56.86V72C56.86 68.69 59.55 66 62.86 66Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.97 62.3301C25.0075 62.3301 27.47 59.8676 27.47 56.8301C27.47 53.7925 25.0075 51.3301 21.97 51.3301C18.9324 51.3301 16.47 53.7925 16.47 56.8301C16.47 59.8676 18.9324 62.3301 21.97 62.3301Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.86 66H25.14C28.45 66 31.14 68.69 31.14 72V78.83H12.86V72C12.86 68.69 15.55 66 18.86 66Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMate);
export default __webpack_public_path__ + "static/media/mate.78767e44d50bbe8a6e3da8d633bd10ca.svg";
export { ForwardRef as ReactComponent };